import { render } from "./PrintPostpaidPaymentVoucher.vue?vue&type=template&id=2557d70a&scoped=true"
import script from "./PrintPostpaidPaymentVoucher.vue?vue&type=script&lang=js"
export * from "./PrintPostpaidPaymentVoucher.vue?vue&type=script&lang=js"

import "./PrintPostpaidPaymentVoucher.vue?vue&type=style&index=0&id=2557d70a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2557d70a"

export default script